/**
 * GoogleAnalytics — DÉSORMAIS INERTE. Le composant ne rend plus rien.
 *
 * Ce qu'il faisait avant le chantier « pages légales » : il injectait
 * `gtag.js` via Helmet dès que `REACT_APP_GA_MEASUREMENT_ID` était défini,
 * sur la home v2 et l'ancienne home, sans la moindre garde de
 * consentement. gtag pose des cookies : le jour où cet identifiant aurait
 * été renseigné, le site aurait déposé des traceurs avant toute réponse
 * du visiteur — exactement ce que la politique cookies interdit.
 *
 * Aucun identifiant n'était configuré nulle part dans le dépôt : le
 * composant rendait donc `null` en pratique. Le trou était latent, pas
 * ouvert. Il est refermé avant de l'être.
 *
 * Google Analytics passe maintenant par `lib/consent.js` comme les pixels
 * TikTok et Meta : déclaré au démarrage, chargé UNIQUEMENT après un
 * « Accepter » explicite. Les pages qui montent encore ce composant
 * peuvent le garder — il ne fait plus rien — ou le retirer.
 */
import { hasConsent } from '../../lib/consent';

export default function GoogleAnalytics() {
  return null;
}

/**
 * Envoi d'un événement gtag. Silencieux tant que le consentement n'est
 * pas accordé (auquel cas `window.gtag` n'existe même pas : le script
 * n'a jamais été chargé). La garde explicite reste, pour que la règle
 * soit lisible ici aussi et pas seulement à l'autre bout du module.
 */
export function trackEvent(eventName, params) {
  if (typeof window === 'undefined') return;
  if (!hasConsent()) return;
  if (typeof window.gtag === 'function') window.gtag('event', eventName, params);
}
